import { useMemo } from 'react'

const RoundHistoryTable = ({ rounds }) => {
  const top8LowestDiffRounds = useMemo(() => {
    if (!rounds || rounds.length === 0) return new Set()

    // Get 20 most recent rounds
    const recentRounds = [...rounds]
      .sort((a, b) => new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime())
      .slice(0, 20)
      .filter(r => r.roundDifferential != null)

    // Sort by differential ascending
    const lowestDiffs = recentRounds.sort((a, b) => a.roundDifferential - b.roundDifferential)

    // Take top 8 and return set of their IDs
    return new Set(lowestDiffs.slice(0, 8).map(r => r.roundId))
  }, [rounds])

  if (!rounds || rounds.length === 0) {
    return <div style={{ textAlign: 'center', padding: '2px' }}>No rounds found.</div>
  }

  return (
    <div className="admin-table-container">
      <table className="admin-table">
        <thead>
          <tr>
            <th>Date</th>
            <th style={{ textAlign: 'left' }}>Course</th>
            <th>Hcp</th>
            <th>Gross</th>
            <th>Net</th>
            <th>Diff</th>
          </tr>
        </thead>
        <tbody>
          {rounds.map((round, index) => {
            const isLowestDiff = top8LowestDiffRounds.has(round.roundId)
            return (
              <tr key={round.roundId} style={index >= 20 ? { backgroundColor: '#e6e6e6' } : {}}>
                <td style={{ fontSize: '0.85rem' }}>
                  {new Date(round.eventDate.includes('T') || round.eventDate.includes('/') ? round.eventDate : round.eventDate + 'T12:00:00').toLocaleDateString()}
                </td>
                <td style={{ textAlign: 'left', paddingLeft: '10px', fontSize: '0.85rem' }}>
                  {round.eventCourse}
                </td>
                <td>{round.golferHcp}</td>
                <td style={{ fontWeight: 'bold' }}>{round.grossScore}</td>
                <td style={{ fontWeight: 'bold' }}>{round.netScore}</td>
                <td style={{
                  fontWeight: 'bold',
                  color: isLowestDiff ? '#0C0' : 'inherit'
                }}>
                  {round.roundDifferential != null ? Number(round.roundDifferential).toFixed(1) : '-'}
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>
  )
}

export default RoundHistoryTable
